/* THE NINETY V13 motion orchestration – nonblocking enhancement */
(()=>{'use strict';
 const root=document.documentElement;
 const reduced=matchMedia('(prefers-reduced-motion: reduce)');
 const active=()=>!reduced.matches&&!window.Shopify?.designMode&&document.body.dataset.motionEnabled!=='false';
 const sync=()=>root.classList.toggle('n13-motion',active());
 sync();reduced.addEventListener?.('change',sync);
 const initialize=()=>{
  const cards=[...document.querySelectorAll('.ninety-real-grid .ninety-real-card')];
  cards.forEach((card,index)=>{
   card.style.setProperty('--n13-entry',(24+index%4*7)+'px');
   card.style.transitionDelay=active()?((index%4)*75)+'ms':'0ms';
   const a=card.querySelector('.ninety-real-visual[href]');
   if(a){a.setAttribute('aria-label',(card.querySelector('.ninety-real-info a')?.textContent||'Product').trim());}
  });
  const hero=document.querySelector('.ninety-opening');
  if(hero&&active()){
   hero.dataset.n13Ready='true';
  }
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize,{once:true});else initialize();
 document.addEventListener('ninety:route:load',initialize);
 document.addEventListener('shopify:section:load',initialize);
})();
